module.exports = __webpack_public_path__ + "img/Carousel_1.eb5a92e5.jpg";